export default __webpack_public_path__ + "static/media/smiles-logo.8be271d2.svg";